/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PetAllergyModel
 */
export interface PetAllergyModel {
    /**
     * 
     * @type {number}
     * @memberof PetAllergyModel
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PetAllergyModel
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetAllergyModel
     */
    writein?: boolean;
}

/**
 * Check if a given object implements the PetAllergyModel interface.
 */
export function instanceOfPetAllergyModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PetAllergyModelFromJSON(json: any): PetAllergyModel {
    return PetAllergyModelFromJSONTyped(json, false);
}

export function PetAllergyModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetAllergyModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'writein': !exists(json, 'writein') ? undefined : json['writein'],
    };
}

export function PetAllergyModelToJSON(value?: PetAllergyModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'writein': value.writein,
    };
}

